import React from 'react'
import LinkButton from '@components/common/LinkButton'
import SoftDropdownButton from '../../common/SoftDropDownButton'

const MainMenu = ({ openMegaMenu, handleMenu, openLookbookMenu, handleLookbookMenu }) => {
  return (
    <React.Fragment>
      <section className="relative gap-x-6 text-black text-sm ml-8">
        {/* DESKTOP */}
        <section className="hidden lg:flex justify-between flex-row items-start lg:items-center max-w-[1440px] mx-auto flex-1 gap-x-6 xl:gap-x-8 gap-y-8">
          <SoftDropdownButton
            label={"SHOP"}
            onClick={handleMenu}
            disableDefaultDropdown={true}
            openOnHover={true}
            className={'flex-1 justify-between'}
            isOpenRef={openMegaMenu}
          />
          {process.env.GATSBY_STORE !== "PH" ? (
			<>
                <LinkButton className={'font-bold text-danger'} label={'4TH OF JULY SALE'} to={"/collections/4th-of-july-summer-steals/"} ariaLabel='SALE' />
                <LinkButton className="uppercase" label={'$60 Summer It Girl Sets'} to={"/collections/60-sets/"} ariaLabel='$60 SUMMER SETS' />
				<LinkButton label={'NEW'} to={"/collections/new-arrivals/"} ariaLabel='NEW' />
				<LinkButton label={'BEST SELLERS'} to="/collections/bestsellers" ariaLabel='BEST SELLERS' />
				{/* <LinkButton label={'LOOKBOOK'} to="/lookbooks/studio-to-sea" ariaLabel='LOOKBOOK' /> */}
				<SoftDropdownButton
					label={"LOOKBOOK"}
					onClick={handleLookbookMenu}
					disableDefaultDropdown={true}
					openOnHover={true}
					className={'flex-1 justify-between'}
					isOpenRef={openLookbookMenu}
				/>
			</>
		  ) : (
			<>
				<LinkButton className={'font-bold text-danger'} label={'SALE'} to={"/collections/sale"} ariaLabel='SALE' />
				<LinkButton label={'P3500 SUMMER SETS'} to={"/collections/3500-sets"} ariaLabel='P3500 SUMMER SETS' />
				<LinkButton className={'hidden xl:block'} label={'CORE COLLECTION'} to="/collections/the-core-collection" ariaLabel='CORE COLLECTION' />
				<LinkButton label={'NEW'} to={"/collections/new-arrivals/"} ariaLabel='NEW' />
				<LinkButton label={'BEST SELLERS'} to="/collections/bestsellers" ariaLabel='BEST SELLERS' />
			</>
		  )}
        </section>
      </section>
    </React.Fragment>
  );
}

export default MainMenu